import { render, staticRenderFns } from "./WelcomeStep.vue?vue&type=template&id=6d857f52&"
import script from "./WelcomeStep.vue?vue&type=script&lang=js&"
export * from "./WelcomeStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports